import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from './components/Layout/Layout'
import PreviewColors from './components/PreviewColors/PreviewColors'
import LookingForColors from './components/LookingForColors/LookingForColors'

export default function App() {
	return (
		<Routes>
			<Route path='/' element={<Layout />}>
				<Route index element={<PreviewColors />} />
				<Route path=':keyword' element={<LookingForColors />} />
				<Route path=':keyword/:sub' element={<Navigate to='/' replace />} />
				<Route path='*' element={<Navigate to='/' replace />} />
			</Route>
		</Routes>
	)
}
